/* src/components/AnnouncementBar.jsx */
import React, { useState, useEffect } from 'react';
import { HashLink } from 'react-router-hash-link';

const AnnouncementBar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const message = "Get the Hair Transplant Guide (2025) (FREE)!";
  
  // Check if announcement bar was dismissed in a previous session
  useEffect(() => {
    const isDismissed = sessionStorage.getItem('announcementBarDismissed');
    if (isDismissed === 'true') {
      setIsVisible(false);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    sessionStorage.setItem('announcementBarDismissed', 'true');
  };

  // Define the background color once to ensure consistency
  const backgroundColor = "#fdba74";

  if (!isVisible) return null;

  return (
    <div className="w-full" style={{ backgroundColor: backgroundColor }}>
      {/* Centered message for all screen sizes */}
      <div className="w-full flex items-center justify-center py-1">
        <div className="flex items-center gap-4">
          <HashLink 
            smooth 
            to="/guide"
            className="cursor-pointer hover:underline"
          >
            <span className="py-1 inline-block text-white text-sm sm:text-base md:text-base font-bold md:font-bold">
              {message}
            </span>
          </HashLink>
          
          {/* Dismiss button */}
          <button
            onClick={handleDismiss}
            className="text-white hover:text-gray-200 focus:outline-none p-1"
            aria-label="Dismiss announcement"
          >
            <svg 
              className="w-4 h-4 sm:w-5 sm:h-5" 
              xmlns="http://www.w3.org/2000/svg" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M6 18L18 6M6 6l12 12" 
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;